export default {
  en: {
    account: [
      {
        title: 'How do I transfer funds into my MariBank account?',
        fileName: '006',
      },
      { title: 'What is Mari Savings Account?', fileName: '037' },
      {
        title: 'How can I see my Mari Savings Account number?',
        fileName: '038',
      },
      { title: 'How can I close my account?', fileName: '043' },
      {
        title:
          'How do I check my Mari Savings Account balance and transaction history?',
        fileName: '049',
      },
      { title: 'What should I do to keep my account safe?', fileName: '073' },
      { title: 'How can I open a Mari Savings Account?', fileName: '075' },
      {
        title:
          'What are the documents required to open a Mari Savings Account?',
        fileName: '076',
      },
      {
        title:
          'Can I sign up for multiple Mari Savings Accounts on the MariBank app?',
        fileName: '078',
      },
      { title: 'Who can apply for a Mari Savings Account?', fileName: '081' },
      {
        title: 'How do I retrieve my details from Singpass Myinfo?',
        fileName: '084',
      },
      {
        title:
          'How long will the Mari Savings Account application and account opening take?',
        fileName: '085',
      },
      {
        title:
          'Is there a minimum age requirement to open a Mari Savings Account?',
        fileName: '086',
      },
      {
        title:
          'My Mari Savings Acccount application is incomplete. How can I continue?',
        fileName: '087',
      },
      {
        title:
          'How can I check the status of my Mari Savings Account application?',
        fileName: '089',
      },
      {
        title:
          'How do I freeze account activities if I suspect fraudulent activities on my account?',
        fileName: '099',
      },
      {
        title:
          'What is the maximum amount of deposit I can maintain in the Mari Savings Account?',
        fileName: '101',
      },
      {
        title: 'What does it mean when I have reached the Maximum Deposit?',
        fileName: '102',
      },
      {
        title: 'How is the interest on my Mari Savings Account calculated?',
        fileName: '103',
      },
      {
        title:
          'Why does my interest credited differ daily on my Mari Savings Account?',
        fileName: '104',
      },
      {
        title:
          'What are the Terms and Conditions governing Mari Savings Account?',
        fileName: '105',
      },
      {
        title: 'What is the interest rate offered on the Mari Savings Account?',
        fileName: '107',
      },
      {
        title: 'Why was my Singpass Face Verification unsuccessful?',
        fileName: '063',
      },
      {
        title: 'How do I withdraw funds from my MariBank account?',
        fileName: '146',
      },
      { title: 'Who can apply for a Mari Business Account?', fileName: '503' },
      {
        title:
          'What is the interest rate offered on the Mari Business Account?',
        fileName: '516',
      },
      { title: 'How can I open a Mari Business Account?', fileName: '501' },
      {
        title:
          'How long will the Mari Business Account application and account opening take?',
        fileName: '505',
      },
      {
        title:
          'My Mari Business Account application is incomplete. How can I continue?',
        fileName: '559',
      },
      {
        title:
          'What are the documents required to open a Mari Business Account?',
        fileName: '504',
      },
      {
        title:
          'Can I sign up for multiple Mari Business Accounts on the MariBank app?',
        fileName: '502',
      },
      { title: 'What is Mari Business Account?', fileName: '500' },
      {
        title: 'How can I see my Mari Business Account number?',
        fileName: '521',
      },
      {
        title:
          'How do I check my account balance and transaction history on my Mari Business Account?',
        fileName: '513',
      },
      {
        title:
          'Is there a minimum balance that I need to maintain in the Mari Business Account?',
        fileName: '511',
      },
      {
        title:
          'Are my deposits in Mari Business Account insured by the Deposit Insurance Scheme?',
        fileName: '520',
      },
      {
        title:
          'Why do I need a Shopee Shop account to apply for Mari Business Account?',
        fileName: '552',
      },
      {
        title:
          'How can I withdraw my Shopee Seller balance to my Mari Business Account?',
        fileName: '555',
      },
      {
        title:
          'What are the Terms &amp; Conditions governing Mari Business Account?',
        fileName: '509',
      },
      {
        title: 'How is the interest on my Mari Business Account calculated?',
        fileName: '514',
      },
      {
        title:
          'Why does my interest credited differ daily on my Mari Business Account?',
        fileName: '515',
      },
      {
        title:
          'Is there a fee imposed for withdrawals from my Shopee Seller Balance into my Mari Business Account?',
        fileName: '557',
      },
      {
        title:
          'What are the fees and charges involved in opening and maintaining the Mari Business Account?',
        fileName: '510',
      },
      {
        title: 'Why do I have to provide my mobile number for registration?',
        fileName: '077',
      },
    ],
    address: [
      {
        title:
          'Will the bank send any documents to the residential address registered on my Mari Savings Account?',
        fileName: '090',
      },
      {
        title:
          'Will the bank send any documents to the residential address registered on my Mari Business Account?',
        fileName: '560',
      },
    ],
    app: [
      {
        title: 'Which operating systems support the use of MariBank app?',
        fileName: '003',
      },
      { title: 'How do I change my app language?', fileName: '005' },
      { title: 'What is my transfer limit?', fileName: '020' },
      { title: 'How do I activate Touch ID / Face ID?', fileName: '060' },
      {
        title: 'Can I use the MariBank app on more than one device?',
        fileName: '061',
      },
      { title: 'Is the MariBank app secure?', fileName: '072' },
      {
        title:
          'How do I freeze account activities if I suspect fraudulent activities on my account?',
        fileName: '099',
      },
      {
        title: 'Do I have to pay to access my personal data?',
        fileName: '129',
      },
    ],
    ATM: [
      {
        title:
          'Does MariBank have a physical branch or ATM that I can make cash deposits or withdrawals from?',
        fileName: '096',
      },
    ],
    balance: [
      {
        title:
          'What should I do if a transaction fails but my balance gets deducted?',
        fileName: '012',
      },
      {
        title:
          'How do I check my Mari Savings Account balance and transaction history?',
        fileName: '049',
      },
      {
        title:
          'What is the maximum amount of deposit I can maintain in the Mari Savings Account?',
        fileName: '101',
      },
      {
        title: 'What does it mean when I have reached the Maximum Deposit?',
        fileName: '102',
      },
      {
        title:
          'How do I check my account balance and transaction history on my Mari Business Account?',
        fileName: '513',
      },
      {
        title:
          'Is there a minimum balance that I need to maintain in the Mari Business Account?',
        fileName: '511',
      },
      {
        title:
          'Is there a fee imposed for withdrawals from my Shopee Seller Balance into my Mari Business Account?',
        fileName: '557',
      },
    ],
    branch: [
      {
        title:
          'Does MariBank have a physical branch or ATM that I can make cash deposits or withdrawals from?',
        fileName: '096',
      },
    ],
    card: [{ title: 'Does MariBank issue debit cards?', fileName: '035' }],
    cash: [
      {
        title:
          'Does MariBank have a physical branch or ATM that I can make cash deposits or withdrawals from?',
        fileName: '096',
      },
    ],
    close: [{ title: 'How can I close my account?', fileName: '043' }],
    currency: [
      { title: 'Can I transfer money in foreign currency?', fileName: '025' },
    ],
    deposit: [
      {
        title:
          'Are my deposits in Mari Savings Account insured by the Deposit Insurance Scheme?',
        fileName: '095',
      },
      {
        title:
          'What is the maximum amount of deposit I can maintain in the Mari Savings Account?',
        fileName: '101',
      },
      {
        title:
          'Are my deposits in Mari Business Account insured by the Deposit Insurance Scheme?',
        fileName: '520',
      },
    ],
    device: [
      { title: 'How do I activate Touch ID / Face ID?', fileName: '060' },
      {
        title: 'Can I use the MariBank app on more than one device?',
        fileName: '061',
      },
    ],
    email: [
      { title: 'How can I update my email address?', fileName: '066' },
      {
        title: 'How do I stop receiving marketing emails from MariBank?',
        fileName: '124',
      },
      {
        title:
          'What type of marketing messages will I receive if I give my consent? Can I choose to be notified of certain product updates only?',
        fileName: '127',
      },
    ],
    face: [
      { title: 'What is Singpass Face Verification?', fileName: '062' },
      {
        title: 'Why was my Singpass Face Verification unsuccessful?',
        fileName: '063',
      },
      {
        title: 'Why and how is Singpass Face Verification used?',
        fileName: '143',
      },
    ],
    'Face ID': [
      { title: 'How do I activate Touch ID / Face ID?', fileName: '060' },
    ],
    'Touch ID': [
      { title: 'How do I activate Touch ID / Face ID?', fileName: '060' },
    ],
    fee: [
      {
        title:
          'What are the fees and charges for opening and maintaining the Mari Savings Account?',
        fileName: '022',
      },
      {
        title: 'Are there any fees associated with using Scan and Pay?',
        fileName: '110',
      },
      {
        title: 'Do I have to pay to access my personal data?',
        fileName: '129',
      },
      { title: 'What is Mari Business Account?', fileName: '500' },
      {
        title:
          'Is there a fee imposed for withdrawals from my Shopee Seller Balance into my Mari Business Account?',
        fileName: '557',
      },
      {
        title:
          'What are the fees and charges involved in opening and maintaining the Mari Business Account?',
        fileName: '510',
      },
    ],
    forgot: [
      { title: 'I forgot my password. What should I do?', fileName: '039' },
      { title: 'I forgot my Secure PIN. What should I do?', fileName: '040' },
    ],
    fraud: [
      {
        title:
          'Will MariBank ask for my confidential information (e.g. username, password, Secure PIN, etc) over the phone, email or SMS?',
        fileName: '071',
      },
      { title: 'Is the MariBank app secure?', fileName: '072' },
      { title: 'What should I do to keep my account safe?', fileName: '073' },
      {
        title:
          'How do I freeze account activities if I suspect fraudulent activities on my account?',
        fileName: '099',
      },
    ],
    funds: [
      {
        title: 'How do I transfer funds into my MariBank account?',
        fileName: '006',
      },
      {
        title:
          'What payment channels can I use to transfer funds from other banks to MariBank and vice versa?',
        fileName: '015',
      },
      { title: 'How do I transfer funds using PayNow?', fileName: '016' },
      {
        title:
          'How do I freeze account activities if I suspect fraudulent activities on my account?',
        fileName: '099',
      },
      {
        title: 'How do I withdraw funds from my MariBank account?',
        fileName: '146',
      },
    ],
    history: [
      {
        title:
          'What should I do if I have made a transfer but it is not reflected in my Transaction History?',
        fileName: '010',
      },
      {
        title: 'How do I get a proof of transaction after completing one?',
        fileName: '011',
      },
      {
        title:
          'How do I check my Mari Savings Account balance and transaction history?',
        fileName: '049',
      },
      {
        title:
          'How do I check my account balance and transaction history on my Mari Business Account?',
        fileName: '513',
      },
    ],
    information: [
      { title: 'How can I update my personal information?', fileName: '067' },
      {
        title:
          'Will MariBank ask for my confidential information (e.g. username, password, Secure PIN, etc) over the phone, email or SMS?',
        fileName: '071',
      },
    ],
    international: [
      {
        title:
          'Can I send or receive international transfers through my MariBank account?',
        fileName: '023',
      },
    ],
    language: [{ title: 'How do I change my app language?', fileName: '005' }],
    license: [{ title: 'Is my money safe with MariBank?', fileName: '002' }],
    limit: [
      { title: 'How do I change my transfer limit?', fileName: '019' },
      { title: 'What is my transfer limit?', fileName: '020' },
    ],
    login: [
      { title: 'How do I activate Touch ID / Face ID?', fileName: '060' },
      {
        title: 'Why was my Singpass Face Verification unsuccessful?',
        fileName: '063',
      },
    ],
    MariBank: [
      { title: 'What is MariBank?', fileName: '001' },
      {
        title:
          'How do I freeze account activities if I suspect fraudulent activities on my account?',
        fileName: '099',
      },
    ],
    MAS: [{ title: 'Is my money safe with MariBank?', fileName: '002' }],
    mobile: [
      {
        title:
          'My mobile number has changed. How do I update my mobile number registered with MariBank?',
        fileName: '045',
      },
    ],
    Myinfo: [
      { title: 'What is Singpass Myinfo?', fileName: '082' },
      {
        title: 'How do I retrieve my details from Singpass Myinfo?',
        fileName: '084',
      },
    ],
    open: [
      { title: 'How can I open a Mari Savings Account?', fileName: '075' },
      {
        title:
          'What are the documents required to open a Mari Savings Account?',
        fileName: '076',
      },
      {
        title: 'Why do I have to provide my mobile number for registration?',
        fileName: '077',
      },
      {
        title:
          'Can I sign up for multiple Mari Savings Accounts on the MariBank app?',
        fileName: '078',
      },
      {
        title: 'I am having problems with my registration. What should I do?',
        fileName: '079',
      },
      { title: 'Who can apply for a Mari Savings Account?', fileName: '081' },
      {
        title: 'How do I retrieve my details from Singpass Myinfo?',
        fileName: '084',
      },
      {
        title:
          'How long will the Mari Savings Account application and account opening take?',
        fileName: '085',
      },
      {
        title:
          'Is there a minimum age requirement to open a Mari Savings Account?',
        fileName: '086',
      },
      {
        title:
          'My Mari Savings Acccount application is incomplete. How can I continue?',
        fileName: '087',
      },
      {
        title:
          'How can I check the status of my Mari Savings Account application?',
        fileName: '089',
      },
      {
        title: 'Why was my Singpass Face Verification unsuccessful?',
        fileName: '063',
      },
      { title: 'How can I open a Mari Business Account?', fileName: '501' },
      {
        title:
          'My Mari Business Account application is incomplete. How can I continue?',
        fileName: '559',
      },
      {
        title:
          'How can I check on the status of my Mari Business Account opening?',
        fileName: '507',
      },
      {
        title:
          'What are the documents required to open a Mari Business Account?',
        fileName: '504',
      },
      {
        title:
          'What are the fees and charges involved in opening and maintaining the Mari Business Account?',
        fileName: '510',
      },
    ],
    OTP: [
      {
        title: 'What should I do if I do not receive an SMS OTP?',
        fileName: '046',
      },
      {
        title: 'What should I do if I do not receive an Email OTP?',
        fileName: '058',
      },
    ],
    password: [
      { title: 'I forgot my password. What should I do?', fileName: '039' },
      { title: 'How do I change my password?', fileName: '041' },
    ],
    PayNow: [
      { title: 'How do I transfer funds using PayNow?', fileName: '016' },
      {
        title: 'How do I register for PayNow or PayNow Corporate?',
        fileName: '026',
      },
      {
        title:
          'Can I register for PayNow with Mari Savings Account if both my mobile number and NRIC are registered with another bank?',
        fileName: '027',
      },
      {
        title: 'How do I deregister my PayNow from MariBank?',
        fileName: '029',
      },
      {
        title: 'How do I edit my PayNow details with MariBank?',
        fileName: '030',
      },
      {
        title:
          'Do I need to register for PayNow to perform an outgoing PayNow transfer?',
        fileName: '031',
      },
      {
        title:
          'How do I generate my personalised PayNow QR Code using the MariBank app?',
        fileName: '113',
      },
      { title: 'What is My QR?', fileName: '147' },
    ],
    permission: [
      {
        title: 'How do I withdraw consent for the use of my personal data?',
        fileName: '128',
      },
    ],
    PIN: [
      { title: 'I forgot my Secure PIN. What should I do?', fileName: '040' },
      { title: 'How do I change my Secure PIN?', fileName: '042' },
    ],
    recipient: [
      { title: 'How do I save a recipient?', fileName: '017' },
      {
        title:
          'I transferred to a wrong recipient. Can I cancel the transaction and recover the funds?',
        fileName: '018',
      },
    ],
    register: [
      { title: 'How can I open a Mari Savings Account?', fileName: '075' },
      {
        title:
          'What are the documents required to open a Mari Savings Account?',
        fileName: '076',
      },
      {
        title: 'Why do I have to provide my mobile number for registration?',
        fileName: '077',
      },
      {
        title:
          'Can I sign up for multiple Mari Savings Accounts on the MariBank app?',
        fileName: '078',
      },
      {
        title: 'I am having problems with my registration. What should I do?',
        fileName: '079',
      },
      { title: 'Who can apply for a Mari Savings Account?', fileName: '081' },
      {
        title:
          'How long will the Mari Savings Account application and account opening take?',
        fileName: '085',
      },
      {
        title:
          'Is there a minimum age requirement to open a Mari Savings Account?',
        fileName: '086',
      },
      {
        title:
          'My Mari Savings Acccount application is incomplete. How can I continue?',
        fileName: '087',
      },
      {
        title:
          'How can I check the status of my Mari Savings Account application?',
        fileName: '089',
      },
      { title: 'How can I open a Mari Business Account?', fileName: '501' },
      {
        title:
          'My Mari Business Account application is incomplete. How can I continue?',
        fileName: '559',
      },
      {
        title:
          'How can I register my interest for Mari Savings Account if I have not received an invite?',
        fileName: '148',
      },
      {
        title:
          'How can I register my interest for Mari Business Account if I have not received an invite?',
        fileName: '149',
      },
    ],
    reset: [
      { title: 'I forgot my password. What should I do?', fileName: '039' },
      { title: 'I forgot my Secure PIN. What should I do?', fileName: '040' },
    ],
    secure: [
      {
        title:
          'Will MariBank ask for my confidential information (e.g. username, password, Secure PIN, etc) over the phone, email or SMS?',
        fileName: '071',
      },
      { title: 'Is the MariBank app secure?', fileName: '072' },
      { title: 'What should I do to keep my account safe?', fileName: '073' },
    ],
    settings: [
      { title: 'How do I activate Touch ID / Face ID?', fileName: '060' },
    ],
    Shopee: [
      {
        title:
          'How do I link my MariBank app to my Shopee or Shopee Shop account?',
        fileName: '050',
      },
      {
        title:
          'Why do I need a Shopee Shop account to apply for Mari Business Account?',
        fileName: '552',
      },
      {
        title:
          'How can I withdraw my Shopee Seller balance to my Mari Business Account?',
        fileName: '555',
      },
      {
        title:
          'Is there a fee imposed for withdrawals from my Shopee Seller Balance into my Mari Business Account?',
        fileName: '557',
      },
    ],
    signup: [
      { title: 'How can I open a Mari Savings Account?', fileName: '075' },
      {
        title:
          'What are the documents required to open a Mari Savings Account?',
        fileName: '076',
      },
      {
        title: 'Why do I have to provide my mobile number for registration?',
        fileName: '077',
      },
      {
        title:
          'Can I sign up for multiple Mari Savings Accounts on the MariBank app?',
        fileName: '078',
      },
      {
        title: 'I am having problems with my registration. What should I do?',
        fileName: '079',
      },
      { title: 'Who can apply for a Mari Savings Account?', fileName: '081' },
      {
        title: 'How do I retrieve my details from Singpass Myinfo?',
        fileName: '084',
      },
      {
        title:
          'How long will the Mari Savings Account application and account opening take?',
        fileName: '085',
      },
      {
        title:
          'Is there a minimum age requirement to open a Mari Savings Account?',
        fileName: '086',
      },
      {
        title:
          'My Mari Savings Acccount application is incomplete. How can I continue?',
        fileName: '087',
      },
      {
        title:
          'How can I check the status of my Mari Savings Account application?',
        fileName: '089',
      },
      {
        title: 'Why was my Singpass Face Verification unsuccessful?',
        fileName: '063',
      },
      {
        title:
          'My Mari Business Account application is incomplete. How can I continue?',
        fileName: '559',
      },
    ],
    singpass: [
      { title: 'What is Singpass Face Verification?', fileName: '062' },
      {
        title: 'Why was my Singpass Face Verification unsuccessful?',
        fileName: '063',
      },
      { title: 'What is Singpass Myinfo?', fileName: '082' },
      {
        title: 'How do I retrieve my details from Singpass Myinfo?',
        fileName: '084',
      },
      {
        title: 'Why and how is Singpass Face Verification used?',
        fileName: '143',
      },
    ],
    statement: [
      {
        title: 'Where can I view my Mari Savings Account e-Statement?',
        fileName: '091',
      },
      {
        title:
          'When will I receive my e-Statement for my Mari Savings Account?',
        fileName: '092',
      },
      {
        title:
          'What should I do if I want to get a paper e-Statement for my Mari Savings Account?',
        fileName: '094',
      },
      {
        title: 'Where can I view my Mari Business Account e-Statement?',
        fileName: '517',
      },
      {
        title:
          'When will I receive my e-Statement for my Mari Business Account?',
        fileName: '518',
      },
      {
        title:
          'What should I do if I want to get a paper e-Statement for my Mari Business Account?',
        fileName: '519',
      },
    ],
    transaction: [
      {
        title:
          'What should I do if I have made a transfer but it is not reflected in my Transaction History?',
        fileName: '010',
      },
      {
        title: 'How do I get a proof of transaction after completing one?',
        fileName: '011',
      },
      {
        title:
          'What should I do if a transaction fails but my balance gets deducted?',
        fileName: '012',
      },
      {
        title:
          'How do I check my Mari Savings Account balance and transaction history?',
        fileName: '049',
      },
      {
        title: 'How do I report an erroneous or unauthorised transaction?',
        fileName: '139',
      },
      {
        title:
          'I have made an unauthorised transaction report. What happens next?',
        fileName: '140',
      },
      {
        title:
          'How do I check my account balance and transaction history on my Mari Business Account?',
        fileName: '513',
      },
    ],
    transfer: [
      {
        title: 'How do I transfer funds into my MariBank account?',
        fileName: '006',
      },
      { title: 'How do I check the status of my transfer?', fileName: '008' },
      {
        title:
          'What should I do if I have made a transfer but my recipient has not received it?',
        fileName: '009',
      },
      {
        title:
          'What should I do if I have made a transfer but it is not reflected in my Transaction History?',
        fileName: '010',
      },
      {
        title:
          'What payment channels can I use to transfer funds from other banks to MariBank and vice versa?',
        fileName: '015',
      },
      { title: 'How do I transfer funds using PayNow?', fileName: '016' },
      { title: 'How do I save a recipient?', fileName: '017' },
      {
        title:
          'I transferred to a wrong recipient. Can I cancel the transaction and recover the funds?',
        fileName: '018',
      },
      { title: 'How do I change my transfer limit?', fileName: '019' },
      { title: 'What is my transfer limit?', fileName: '020' },
      {
        title:
          'What are the fees and charges for opening and maintaining the Mari Savings Account?',
        fileName: '022',
      },
      {
        title:
          'Can I send or receive international transfers through my MariBank account?',
        fileName: '023',
      },
      {
        title:
          'Do I need to register for PayNow to perform an outgoing PayNow transfer?',
        fileName: '031',
      },
      {
        title:
          'How do I freeze account activities if I suspect fraudulent activities on my account?',
        fileName: '099',
      },
      {
        title: 'What does it mean when I have reached the Maximum Deposit?',
        fileName: '102',
      },
    ],
    update: [
      { title: 'How do I change my password?', fileName: '041' },
      { title: 'How do I change my Secure PIN?', fileName: '042' },
      {
        title:
          'My mobile number has changed. How do I update my mobile number registered with MariBank?',
        fileName: '045',
      },
      { title: 'How can I update my email address?', fileName: '066' },
      { title: 'How can I update my personal information?', fileName: '067' },
      {
        title:
          'Can MariBank send me marketing messages even though I have registered with the National Do Not Call (DNC) Registry?',
        fileName: '125',
      },
      {
        title:
          'What type of marketing messages will I receive if I give my consent? Can I choose to be notified of certain product updates only?',
        fileName: '127',
      },
    ],
    wrong: [
      {
        title:
          'I transferred to a wrong recipient. Can I cancel the transaction and recover the funds?',
        fileName: '018',
      },
    ],
    kill: [
      {
        title:
          'How do I freeze account activities if I suspect fraudulent activities on my account?',
        fileName: '099',
      },
    ],
    switch: [
      {
        title:
          'How do I freeze account activities if I suspect fraudulent activities on my account?',
        fileName: '099',
      },
    ],
    QR: [
      {
        title: 'Which QR codes can I use my Scan and Pay on?',
        fileName: '109',
      },
      {
        title:
          'How do I generate my personalised PayNow QR Code using the MariBank app?',
        fileName: '113',
      },
      { title: 'What is My QR?', fileName: '147' },
    ],
    scan: [
      {
        title: 'Which QR codes can I use my Scan and Pay on?',
        fileName: '109',
      },
      {
        title: 'Are there any fees associated with using Scan and Pay?',
        fileName: '110',
      },
      {
        title:
          'How do I generate my personalised PayNow QR Code using the MariBank app?',
        fileName: '113',
      },
      { title: 'What is My QR?', fileName: '147' },
    ],
    PDPA: [
      { title: 'Where can I find MariBank‘s Privacy Policy?', fileName: '116' },
      { title: 'What is Personal Data?', fileName: '117' },
      {
        title: 'What type of personal data does MariBank collect?',
        fileName: '118',
      },
      {
        title: 'How does MariBank collect and use my personal data?',
        fileName: '119',
      },
      {
        title:
          'How can I access or correct my Personal Data that I have provided to MariBank?',
        fileName: '121',
      },
      {
        title: 'Does MariBank sell my personal data to third parties?',
        fileName: '122',
      },
      {
        title: 'Is my personal data stored in Singapore only?',
        fileName: '123',
      },
      {
        title: 'How do I withdraw consent for the use of my personal data?',
        fileName: '128',
      },
      {
        title: 'Do I have to pay to access my personal data?',
        fileName: '129',
      },
    ],
    privacy: [
      { title: 'Where can I find MariBank‘s Privacy Policy?', fileName: '116' },
      { title: 'What is Personal Data?', fileName: '117' },
      {
        title: 'What type of personal data does MariBank collect?',
        fileName: '118',
      },
      {
        title: 'How does MariBank collect and use my personal data?',
        fileName: '119',
      },
      {
        title:
          'How can I access or correct my Personal Data that I have provided to MariBank?',
        fileName: '121',
      },
      {
        title: 'Does MariBank sell my personal data to third parties?',
        fileName: '122',
      },
      {
        title: 'Is my personal data stored in Singapore only?',
        fileName: '123',
      },
      {
        title: 'How do I stop receiving marketing emails from MariBank?',
        fileName: '124',
      },
    ],
    policy: [
      { title: 'Where can I find MariBank‘s Privacy Policy?', fileName: '116' },
      { title: 'What is Personal Data?', fileName: '117' },
      {
        title: 'What type of personal data does MariBank collect?',
        fileName: '118',
      },
      {
        title: 'How does MariBank collect and use my personal data?',
        fileName: '119',
      },
      {
        title:
          'How can I access or correct my Personal Data that I have provided to MariBank?',
        fileName: '121',
      },
      {
        title: 'Does MariBank sell my personal data to third parties?',
        fileName: '122',
      },
      {
        title: 'Is my personal data stored in Singapore only?',
        fileName: '123',
      },
    ],
    DNC: [
      {
        title:
          'Can MariBank send me marketing messages even though I have registered with the National Do Not Call (DNC) Registry?',
        fileName: '125',
      },
    ],
    '12h': [
      {
        title: 'What is the 12-hour soft token cooling-off period?',
        fileName: '100',
      },
    ],
    token: [
      {
        title: 'What is the 12-hour soft token cooling-off period?',
        fileName: '100',
      },
    ],
    cooling: [
      {
        title: 'What is the 12-hour soft token cooling-off period?',
        fileName: '100',
      },
    ],
    security: [
      {
        title: 'What is the 12-hour soft token cooling-off period?',
        fileName: '100',
      },
    ],
    interest: [
      {
        title: 'How is the interest on my Mari Savings Account calculated?',
        fileName: '103',
      },
      {
        title:
          'Why does my interest credited differ daily on my Mari Savings Account?',
        fileName: '104',
      },
      {
        title: 'What is the interest rate offered on the Mari Savings Account?',
        fileName: '107',
      },
      {
        title:
          'What is the interest rate offered on the Mari Business Account?',
        fileName: '516',
      },
      { title: 'What is Mari Business Account?', fileName: '500' },
      {
        title: 'How is the interest on my Mari Business Account calculated?',
        fileName: '514',
      },
      {
        title:
          'Why does my interest credited differ daily on my Mari Business Account?',
        fileName: '515',
      },
      {
        title:
          'How can I register my interest for Mari Savings Account if I have not received an invite?',
        fileName: '148',
      },
      {
        title:
          'How can I register my interest for Mari Business Account if I have not received an invite?',
        fileName: '149',
      },
    ],
    maximum: [
      {
        title:
          'What is the maximum amount of deposit I can maintain in the Mari Savings Account?',
        fileName: '101',
      },
      {
        title: 'What does it mean when I have reached the Maximum Deposit?',
        fileName: '102',
      },
    ],
    incoming: [
      {
        title: 'What does it mean when I have reached the Maximum Deposit?',
        fileName: '102',
      },
    ],
    terms: [
      {
        title:
          'What are the Terms and Conditions governing Mari Savings Account?',
        fileName: '105',
      },
      {
        title:
          'What are the Terms &amp; Conditions governing Mari Business Account?',
        fileName: '509',
      },
    ],
    conditions: [
      {
        title:
          'What are the Terms and Conditions governing Mari Savings Account?',
        fileName: '105',
      },
      {
        title:
          'What are the Terms &amp; Conditions governing Mari Business Account?',
        fileName: '509',
      },
    ],
    verification: [
      { title: 'What is Singpass Face Verification?', fileName: '062' },
      {
        title: 'Why was my Singpass Face Verification unsuccessful?',
        fileName: '063',
      },
    ],
    SDIC: [
      {
        title:
          'Are my deposits in Mari Savings Account insured by the Deposit Insurance Scheme?',
        fileName: '095',
      },
    ],
    product: [
      {
        title:
          'What type of marketing messages will I receive if I give my consent? Can I choose to be notified of certain product updates only?',
        fileName: '127',
      },
    ],
    NRIC: [
      {
        title: 'What type of personal data does MariBank collect?',
        fileName: '118',
      },
    ],
    promotion: [
      {
        title: 'How do I stop receiving marketing emails from MariBank?',
        fileName: '124',
      },
      {
        title:
          'Can MariBank send me marketing messages even though I have registered with the National Do Not Call (DNC) Registry?',
        fileName: '125',
      },
      {
        title:
          'What type of marketing messages will I receive if I give my consent? Can I choose to be notified of certain product updates only?',
        fileName: '127',
      },
    ],
    pay: [
      {
        title: 'Which QR codes can I use my Scan and Pay on?',
        fileName: '109',
      },
      {
        title: 'Are there any fees associated with using Scan and Pay?',
        fileName: '110',
      },
      {
        title:
          'How do I generate my personalised PayNow QR Code using the MariBank app?',
        fileName: '113',
      },
      { title: 'What is My QR?', fileName: '147' },
    ],
    savings: [
      { title: 'How do I check the status of my transfer?', fileName: '008' },
      {
        title:
          'What should I do if I have made a transfer but it is not reflected in my Transaction History?',
        fileName: '010',
      },
      {
        title:
          'What should I do if a transaction fails but my balance gets deducted?',
        fileName: '012',
      },
      { title: 'What is Mari Savings Account?', fileName: '037' },
      { title: 'How can I open a Mari Savings Account?', fileName: '075' },
      {
        title:
          'What are the documents required to open a Mari Savings Account?',
        fileName: '076',
      },
      {
        title:
          'Can I sign up for multiple Mari Savings Accounts on the MariBank app?',
        fileName: '078',
      },
      { title: 'Who can apply for a Mari Savings Account?', fileName: '081' },
      {
        title:
          'How long will the Mari Savings Account application and account opening take?',
        fileName: '085',
      },
      {
        title:
          'Is there a minimum age requirement to open a Mari Savings Account?',
        fileName: '086',
      },
      {
        title:
          'My Mari Savings Acccount application is incomplete. How can I continue?',
        fileName: '087',
      },
      {
        title:
          'How can I check the status of my Mari Savings Account application?',
        fileName: '089',
      },
      {
        title:
          'Will the bank send any documents to the residential address registered on my Mari Savings Account?',
        fileName: '090',
      },
      {
        title:
          'Are my deposits in Mari Savings Account insured by the Deposit Insurance Scheme?',
        fileName: '095',
      },
      {
        title:
          'What is the maximum amount of deposit I can maintain in the Mari Savings Account?',
        fileName: '101',
      },
      {
        title: 'What does it mean when I have reached the Maximum Deposit?',
        fileName: '102',
      },
      {
        title: 'How is the interest on my Mari Savings Account calculated?',
        fileName: '103',
      },
      {
        title:
          'What are the Terms and Conditions governing Mari Savings Account?',
        fileName: '105',
      },
      {
        title: 'What is the interest rate offered on the Mari Savings Account?',
        fileName: '107',
      },
      {
        title: 'Why do I have to provide my mobile number for registration?',
        fileName: '077',
      },
    ],
    insure: [
      {
        title:
          'Are my deposits in Mari Savings Account insured by the Deposit Insurance Scheme?',
        fileName: '095',
      },
    ],
    insurance: [
      {
        title:
          'Are my deposits in Mari Savings Account insured by the Deposit Insurance Scheme?',
        fileName: '095',
      },
      {
        title:
          'Are my deposits in Mari Business Account insured by the Deposit Insurance Scheme?',
        fileName: '520',
      },
    ],
    freeze: [
      {
        title:
          'How do I freeze account activities if I suspect fraudulent activities on my account?',
        fileName: '099',
      },
    ],
    scam: [
      {
        title:
          'How do I freeze account activities if I suspect fraudulent activities on my account?',
        fileName: '099',
      },
    ],
    block: [
      {
        title:
          'How do I freeze account activities if I suspect fraudulent activities on my account?',
        fileName: '099',
      },
    ],
    why: [],
    disclosure: [],
    payment: [
      {
        title:
          'How will I receive notifications and alerts about my banking activities?',
        fileName: '137',
      },
      {
        title: 'How do I report an erroneous or unauthorised transaction?',
        fileName: '139',
      },
      {
        title:
          'I have made an unauthorised transaction report. What happens next?',
        fileName: '140',
      },
    ],
    guideline: [],
    user: [],
    holder: [],
    alert: [
      {
        title:
          'How will I receive notifications and alerts about my banking activities?',
        fileName: '137',
      },
    ],
    notification: [
      {
        title:
          'How will I receive notifications and alerts about my banking activities?',
        fileName: '137',
      },
    ],
    unauthorised: [
      {
        title: 'How do I report an erroneous or unauthorised transaction?',
        fileName: '139',
      },
      {
        title:
          'I have made an unauthorised transaction report. What happens next?',
        fileName: '140',
      },
    ],
    report: [
      {
        title: 'How do I report an erroneous or unauthorised transaction?',
        fileName: '139',
      },
      {
        title:
          'I have made an unauthorised transaction report. What happens next?',
        fileName: '140',
      },
    ],
    erroneous: [
      {
        title: 'How do I report an erroneous or unauthorised transaction?',
        fileName: '139',
      },
    ],
    SFV: [
      { title: 'What is Singpass Face Verification?', fileName: '062' },
      {
        title: 'Why was my Singpass Face Verification unsuccessful?',
        fileName: '063',
      },
    ],
    application: [
      {
        title: 'Why was my Singpass Face Verification unsuccessful?',
        fileName: '063',
      },
      {
        title:
          'How can I check on the status of my Mari Business Account opening?',
        fileName: '507',
      },
    ],
    'customer service': [
      {
        title: 'How do I contact MariBank‘s Customer Service?',
        fileName: '145',
      },
    ],
    help: [
      {
        title: 'How do I contact MariBank‘s Customer Service?',
        fileName: '145',
      },
    ],
    contact: [
      {
        title: 'How do I contact MariBank‘s Customer Service?',
        fileName: '145',
      },
    ],
    withdraw: [
      {
        title: 'How do I withdraw funds from my MariBank account?',
        fileName: '146',
      },
    ],
    apply: [
      { title: 'Who can apply for a Mari Business Account?', fileName: '503' },
      {
        title:
          'How long will the Mari Business Account application and account opening take?',
        fileName: '505',
      },
      {
        title:
          'Why do I need a Shopee Shop account to apply for Mari Business Account?',
        fileName: '552',
      },
    ],
    business: [
      { title: 'Who can apply for a Mari Business Account?', fileName: '503' },
      {
        title:
          'What is the interest rate offered on the Mari Business Account?',
        fileName: '516',
      },
      { title: 'How can I open a Mari Business Account?', fileName: '501' },
      {
        title:
          'My Mari Business Account application is incomplete. How can I continue?',
        fileName: '559',
      },
      { title: 'What is Mari Business Account?', fileName: '500' },
      {
        title: 'How can I see my Mari Business Account number?',
        fileName: '521',
      },
      {
        title:
          'Why do I need a Shopee Shop account to apply for Mari Business Account?',
        fileName: '552',
      },
      {
        title:
          'What are the Terms &amp; Conditions governing Mari Business Account?',
        fileName: '509',
      },
    ],
    shop: [
      {
        title:
          'How do I link my MariBank app to my Shopee or Shopee Shop account?',
        fileName: '050',
      },
    ],
    link: [
      {
        title:
          'How do I link my MariBank app to my Shopee or Shopee Shop account?',
        fileName: '050',
      },
      {
        title:
          'How can I withdraw my Shopee Seller balance to my Mari Business Account?',
        fileName: '555',
      },
    ],
    duration: [
      {
        title:
          'How long will the Mari Business Account application and account opening take?',
        fileName: '505',
      },
    ],
    status: [
      {
        title:
          'How can I check on the status of my Mari Business Account opening?',
        fileName: '507',
      },
    ],
    opening: [
      {
        title:
          'How can I check on the status of my Mari Business Account opening?',
        fileName: '507',
      },
      {
        title:
          'What are the fees and charges involved in opening and maintaining the Mari Business Account?',
        fileName: '510',
      },
    ],
    documents: [
      {
        title:
          'What are the documents required to open a Mari Business Account?',
        fileName: '504',
      },
      {
        title:
          'Will the bank send any documents to the residential address registered on my Mari Business Account?',
        fileName: '560',
      },
    ],
    multiple: [
      {
        title:
          'Can I sign up for multiple Mari Business Accounts on the MariBank app?',
        fileName: '502',
      },
    ],
    rates: [{ title: 'What is Mari Business Account?', fileName: '500' }],
    withdrawal: [
      { title: 'What is Mari Business Account?', fileName: '500' },
      {
        title:
          'Is there a fee imposed for withdrawals from my Shopee Seller Balance into my Mari Business Account?',
        fileName: '557',
      },
    ],
    number: [
      {
        title: 'How can I see my Mari Business Account number?',
        fileName: '521',
      },
    ],
    minimum: [
      {
        title:
          'Is there a minimum balance that I need to maintain in the Mari Business Account?',
        fileName: '511',
      },
    ],
    maintain: [
      {
        title:
          'Is there a minimum balance that I need to maintain in the Mari Business Account?',
        fileName: '511',
      },
      {
        title:
          'What are the fees and charges involved in opening and maintaining the Mari Business Account?',
        fileName: '510',
      },
    ],
    change: [
      {
        title:
          'What should I do if there is a change in company details, key person(s) e.g. owner(s) and / or director(s)?',
        fileName: '522',
      },
    ],
    owner: [
      {
        title:
          'What should I do if there is a change in company details, key person(s) e.g. owner(s) and / or director(s)?',
        fileName: '522',
      },
    ],
    director: [
      {
        title:
          'What should I do if there is a change in company details, key person(s) e.g. owner(s) and / or director(s)?',
        fileName: '522',
      },
    ],
    monthly: [
      {
        title: 'Where can I view my Mari Business Account e-Statement?',
        fileName: '517',
      },
      {
        title:
          'When will I receive my e-Statement for my Mari Business Account?',
        fileName: '518',
      },
    ],
    hardcopy: [
      {
        title:
          'What should I do if I want to get a paper e-Statement for my Mari Business Account?',
        fileName: '519',
      },
    ],
    print: [
      {
        title:
          'What should I do if I want to get a paper e-Statement for my Mari Business Account?',
        fileName: '519',
      },
    ],
    calculate: [
      {
        title: 'How is the interest on my Mari Business Account calculated?',
        fileName: '514',
      },
      {
        title:
          'Why does my interest credited differ daily on my Mari Business Account?',
        fileName: '515',
      },
    ],
    difference: [
      {
        title:
          'Why does my interest credited differ daily on my Mari Business Account?',
        fileName: '515',
      },
    ],
    seller: [
      {
        title:
          'Is there a fee imposed for withdrawals from my Shopee Seller Balance into my Mari Business Account?',
        fileName: '557',
      },
    ],
    charges: [
      {
        title:
          'What are the fees and charges involved in opening and maintaining the Mari Business Account?',
        fileName: '510',
      },
    ],
    corporate: [
      {
        title: 'How do I register for PayNow or PayNow Corporate?',
        fileName: '026',
      },
    ],
    bill: [{ title: 'What is a Bill Reference Number?', fileName: '098' }],
    reference: [{ title: 'What is a Bill Reference Number?', fileName: '098' }],
  },
};
